import { Card, CardContent } from "@/components/ui/card";
import { PanelEmptyState } from "@/features/reader/side-panel/PanelEmptyState";
import { GradeDistribution } from "@/types/grading";
import { GradeDistributionChart } from "./GradeDistributionChart";

const SummaryCard = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) => (
  <Card className="shadow-none border border-dashed">
    <CardContent className="py-3">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">
        {label}
      </p>
      <p className="text-lg font-semibold">{value}</p>
    </CardContent>
  </Card>
);

export const GradeDistributionTab = ({
  data,
  isLoading,
  currentGrade,
}: {
  data: GradeDistribution | null;
  isLoading: boolean;
  currentGrade?: string | null;
}) => {
  if (isLoading) {
    return (
      <div className="text-sm text-muted-foreground">Loading distribution…</div>
    );
  }

  if (data === null || data.distribution.length === 0) {
    return (
      <PanelEmptyState
        title="No grades available"
        message="No submissions graded yet."
      />
    );
  }

  const gradedPercent =
    data.total > 0 ? Math.round((data.graded / data.total) * 100) : 0;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3">
        <SummaryCard label="Submissions" value={data.total} />
        <SummaryCard
          label="Graded"
          value={`${data.graded} (${gradedPercent}%)`}
        />
      </div>

      <GradeDistributionChart data={data} currentGrade={currentGrade} />
    </div>
  );
};
